module.exports = __webpack_public_path__ + "static/media/1.d5f77e27.svg";